export const SET_LOADING = "$$AUTH_PROVIDER/SET_LOADING";
export const SET_TOKEN = "$$AUTH_PROVIDER/SET_TOKEN";
export const SET_AUTH = "$$AUTH_PROVIDER/SET_AUTH";
export const SET_ERROR = "$$AUTH_PROVIDER/SET_ERROR";
export const SET_USERNAME = "$$AUTH_PROVIDER/SET_USERNAME";
export const SET_SUPPLIER = "$$AUTH_PROVIDER/SET_SUPPLIER";
export const SET_PROFILE = "$$AUTH_PROVIDER/SET_PROFILE";
export const SET_ROLE = "$$AUTH_PROVIDER/SET_ROLE";
